import { render, staticRenderFns } from "./ResolDeltaThermPvm_1d03_P70.vue?vue&type=template&id=1ddf211f&"
import script from "./ResolDeltaThermPvm_1d03_P70.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaThermPvm_1d03_P70.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports